function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1161"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 110",
    style: {
      fill: "#f9f9f9",
      stroke: "#ececec"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 9.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5104",
    d: "M65.307 2.946h-4.05v-.737A2.209 2.209 0 0 0 59.047 0H56.1a2.209 2.209 0 0 0-2.209 2.209v.736h-4.05A1.841 1.841 0 0 0 48 4.787V6.26a.736.736 0 0 0 .736.74h17.676a.736.736 0 0 0 .736-.736V4.787a1.841 1.841 0 0 0-1.841-1.841zm-9.942-.736a.737.737 0 0 1 .736-.736h2.946a.737.737 0 0 1 .736.736v.736h-4.418z",
    transform: "translate(-36.574 9.216)",
    style: {
      fill: "#eb0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5105",
    d: "M73.594 184a.23.23 0 0 0-.23.241l.608 12.752a2.207 2.207 0 0 0 2.207 2.1h11.184a2.207 2.207 0 0 0 2.207-2.1l.608-12.752a.23.23 0 0 0-.23-.241zm11.122 1.841a.736.736 0 1 1 1.473 0v9.574a.736.736 0 0 1-1.473 0zm-3.682 0a.736.736 0 0 1 1.473 0v9.574a.736.736 0 0 1-1.473 0zm-3.682 0a.736.736 0 1 1 1.473 0v9.574a.736.736 0 0 1-1.473 0z",
    transform: "translate(-60.771 -166.315)",
    style: {
      fill: "#eb0000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.59985c920966f728b96a7944768d0fc3.svg";
export { ForwardRef as ReactComponent };